import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUllageReturnMethod implements BaseEnumType {
  private static allValues: EnumUllageReturnMethod[] = []; // make sure this is top-most
  
  public static none = new EnumUllageReturnMethod(0, "None", "enum_ullage_return_method_none");
  public static driverPickup = new EnumUllageReturnMethod(1, "DriverPickup", "enum_ullage_return_method_driver_pickup");
  public static courier = new EnumUllageReturnMethod(2, "Courier", "enum_ullage_return_method_courier");
  public static customerDropOff = new EnumUllageReturnMethod(3, "CustomerDropOff", "enum_ullage_return_method_customer_drop_off");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUllageReturnMethod.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUllageReturnMethod.none; }
  public isDriverPickup() { return this === EnumUllageReturnMethod.driverPickup; }
  public isCourier() { return this === EnumUllageReturnMethod.courier; }
  public isCustomerDropOff() { return this === EnumUllageReturnMethod.customerDropOff; }

  public static getValues(): readonly EnumUllageReturnMethod[] {
    return EnumUllageReturnMethod.allValues;
  }

  public static getValuesExcept0(): readonly EnumUllageReturnMethod[] {
    return EnumUllageReturnMethod.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUllageReturnMethod {
    const found = EnumUllageReturnMethod.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUllageReturnMethod - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUllageReturnMethod): EnumUllageReturnMethod {
    const found = name ? EnumUllageReturnMethod.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUllageReturnMethod - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUllageReturnMethod>): boolean {
    return this.key === other?.key;
  }
}